import { HttpInterceptors } from "./http.interceptor";

export class CategoryExpensesService extends HttpInterceptors {
	async listCategoryExpenses (filters) {
		const response = await this.axios.get("categoryExpenses/listCategoryExpenses", { params: { filters } });
		return response.data;
	}

	async upsertCategoryExpense (payload) {
		const response = await this.axios.post("categoryExpenses/upsertCategoryExpense", payload);
		return response.data;
	}

	async deleteCategoryExpense (id) {
		const response = await this.axios.delete("categoryExpenses/deleteCategoryExpense", { params: id });
		return response.data;
	}
}
